import { useTranslate } from "ra-core";

import type { ColoredLabeledValue, DealStatus } from "../types";

export const DEAL_STATUSES: { value: DealStatus; color: string }[] = [
  { value: "open", color: "#60a5fa" },
  { value: "late", color: "#f59e0b" },
  { value: "won", color: "#22c55e" },
  { value: "lost", color: "#ef4444" },
];

/** Deal statuses with their translated labels, ready for ChoiceBadge or a SelectInput. */
export const useDealStatusChoices = (): ColoredLabeledValue[] => {
  const translate = useTranslate();
  return DEAL_STATUSES.map((status) => ({
    ...status,
    label: translate(`resources.deals.statuses.${status.value}`),
  }));
};
